import { useTheme } from "../ThemeContext";
import { useState, useEffect, useCallback } from "react";
import { fmt } from "../theme";
import { get, post, put, del } from "../api";
import { Card, EmptyState } from "../components/UI";

const uploadArquivo = async (file, tipo = "geral") => {
  const fd = new FormData();
  fd.append("arquivo", file);
  fd.append("tipo", tipo);
  const r = await fetch("https://mixupbr.com.br/api/upload/", { method: "POST", body: fd });
  return r.json();
};

const toArr = (d) => { if (Array.isArray(d)) return d; if (d && typeof d === "object" && d.id) return [d]; return []; };

/* Máscara de preço: digita "1290" → "12,90" */
const mascaraPreco = (v) => {
  const nums = String(v).replace(/\D/g, "");
  if (!nums) return "";
  const n = parseInt(nums, 10);
  return (n / 100).toFixed(2).replace(".", ",");
};
const desmascarar = (v) => String(v).replace(",", ".").replace(/[^\d.]/g, "");

/* Estilos base */
const _iS = { width:"100%", padding:"12px 14px", borderRadius:10, border:"1px solid #E5E7EB", background:"#F9FAFB", color:"#111", fontSize:14, fontFamily:"inherit", outline:"none" };
const _lS = { fontSize:12, fontWeight:600, color:"#6B7280", marginBottom:6, display:"block" };

function Field({ label, value, onChange, ph, type = "text", money = false }) {
  const handleChange = (e) => {
    if (money) { onChange(mascaraPreco(e.target.value.replace(/\D/g, ""))); }
    else onChange(e.target.value);
  };
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={_lS}>{label}</label>
      <input type={money ? "text" : type} inputMode={money ? "numeric" : undefined}
        placeholder={ph} value={value} onChange={handleChange} style={_iS} />
    </div>
  );
}

function SelectField({ label, value, onChange, options }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={_lS}>{label}</label>
      <select value={value} onChange={e => onChange(e.target.value)} style={_iS}>
        {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

/* Botões de ação da lista */
function AcoesBotoes({ onEditar, onExcluir, onCopiar, C }) {
  return (
    <div style={{ display:"flex", gap:6, marginTop:10 }}>
      <button onClick={onEditar}
        style={{ flex:1, padding:"7px 0", borderRadius:8, border:`1px solid ${C.border}`, background:"transparent", color:C.text, cursor:"pointer", fontSize:12, fontWeight:600 }}>
        ✏️ Editar
      </button>
      {onCopiar && (
        <button onClick={onCopiar}
          style={{ flex:1, padding:"7px 0", borderRadius:8, border:`1px solid ${C.border}`, background:"transparent", color:C.text, cursor:"pointer", fontSize:12, fontWeight:600 }}>
          📋 Copiar
        </button>
      )}
      <button onClick={onExcluir}
        style={{ flex:1, padding:"7px 0", borderRadius:8, border:"none", background:"#E8201A12", color:"#E8201A", cursor:"pointer", fontSize:12, fontWeight:700 }}>
        🗑 Excluir
      </button>
    </div>
  );
}

export default function Cadastro({ sub, lojaId }) {
  const { theme: C } = useTheme();
  const [categorias,    setCategorias]    = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [produtos,      setProdutos]      = useState([]);
  const [adicionais,    setAdicionais]    = useState([]);
  const [caixinhas,     setCaixinhas]     = useState([]);
  const [toast,         setToast]         = useState(null);

  /* Estados de edição */
  const [editCat,  setEditCat]  = useState(null);
  const [editSub,  setEditSub]  = useState(null);
  const [editProd, setEditProd] = useState(null);
  const [editAdi,  setEditAdi]  = useState(null);
  const [editCaixa,setEditCaixa]= useState(null);

  const [fCat,   setFCat]   = useState({ nome: "", descricao: "", ordem: "0" });
  const [fSub,   setFSub]   = useState({ nome: "", categoria_id: "", descricao: "" });
  const [fProd,  setFProd]  = useState({ nome: "", descricao: "", preco: "", categoria_id: "", subcategoria_id: "", disponivel: "1", imagem_url: "" });
  const [fAdi,   setFAdi]   = useState({ nome: "", preco: "", categoria_id: "", obrigatorio: "0", max_escolhas: "1", imagem_url: "" });
  const [fCaixa, setFCaixa] = useState({ nome: "", descricao: "", preco: "", preco_original: "", quantidade_limite: "", ativo: "1", imagem_url: "" });
  const [uploadingCaixa, setUploadingCaixa] = useState(false);
  const [uploadingProd,  setUploadingProd]  = useState(false);
  const [uploadingAdi,   setUploadingAdi]   = useState(false);

  /* Adicionais vinculados ao produto no formulário */
  const [adisDoForm, setAdisDoForm] = useState([]);
  const emptyAdiForm = { nome: "", preco: "", obrigatorio: "0", max_escolhas: "1", imagem_url: "" };
  const [novoAdi, setNovoAdi] = useState({ ...emptyAdiForm });

  const handleUploadProd = async (file) => {
    setUploadingProd(true);
    try { const r = await uploadArquivo(file, "produto"); if (r.url) setFProd(p => ({ ...p, imagem_url: r.url })); }
    catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingProd(false);
  };

  const handleUploadAdiForm = async (file, key) => {
    setUploadingAdi(true);
    try {
      const r = await uploadArquivo(file, "adicional");
      if (r.url) setAdisDoForm(p => p.map(a => a._key === key ? { ...a, imagem_url: r.url } : a));
    } catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingAdi(false);
  };

  const handleUploadCaixa = async (file) => {
    setUploadingCaixa(true);
    try { const r = await uploadArquivo(file, "caixinha"); if (r.url) setFCaixa(p => ({ ...p, imagem_url: r.url })); }
    catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingCaixa(false);
  };

  /* ── PROMOÇÕES ── */
  const emptyPromo = { titulo: "", descricao: "", preco_original: "", preco_promocional: "", imagem_url: "", cor_fundo: "#E8201A", emoji: "🔥", ativo: "1", validade: "" };
  const [promocoes,      setPromocoes]      = useState([]);
  const [promoForm,      setPromoForm]      = useState({ ...emptyPromo });
  const [promoEdit,      setPromoEdit]      = useState(null);
  const [promoSalvando,  setPromoSalvando]  = useState(false);
  const [promoOk,        setPromoOk]        = useState("");
  const [uploadingPromo, setUploadingPromo] = useState(false);

  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2800); };

  const fetchData = useCallback(async () => {
    try {
      const [rC, rS, rP, rA, rCx] = await Promise.all([
        get("categorias_loja",   { loja_id: lojaId }),
        get("subcategorias",     { loja_id: lojaId }),
        get("produtos",          { loja_id: lojaId }),
        get("adicionais",        { loja_id: lojaId }),
        get("caixinha_surpresa", { loja_id: lojaId }),
      ]);
      setCategorias(rC.dados  || []);
      setSubcategorias(rS.dados || []);
      setProdutos(rP.dados    || []);
      setAdicionais(rA.dados  || []);
      setCaixinhas(rCx.dados  || []);
    } catch (e) { console.error(e); }
  }, [lojaId]);

  const fetchPromocoes = useCallback(async () => {
    try { const r = await get("promocoes", { loja_id: lojaId }); setPromocoes(toArr(r.dados)); }
    catch (e) { console.error(e); }
  }, [lojaId]);

  useEffect(() => {
    if (sub === "promocoes") fetchPromocoes();
    else fetchData();
  }, [fetchData, fetchPromocoes, sub]);

  /* ── SUBMIT GENÉRICO (POST ou PUT) ── */
  const submitForm = async (modulo, body, label, resetFn, editId = null) => {
    try {
      const payload = { ...body, loja_id: lojaId };
      /* desmascarar campos de preço */
      ["preco","preco_original","preco_promocional"].forEach(k => { if (payload[k]) payload[k] = desmascarar(payload[k]); });
      let ok = false;
      if (editId) {
        const res = await put(modulo, editId, payload);
        ok = !!res.mensagem;
        if (ok) notify(`${label} atualizado(a)!`);
        else notify(res.error || "Erro ao atualizar", false);
      } else {
        const res = await post(modulo, payload);
        ok = !!res.id;
        if (ok) notify(`${label} cadastrado(a)! ID: ${res.id}`);
        else notify(res.error || "Erro ao cadastrar", false);
      }
      if (ok) { resetFn(); fetchData(); }
    } catch (e) { notify("Erro de conexão", false); }
  };

  /* ── EXCLUIR GENÉRICO ── */
  const excluir = async (modulo, id, label) => {
    if (!window.confirm(`Excluir este(a) ${label}?`)) return;
    try {
      const res = await del(modulo, id);
      if (res.mensagem) { notify(`${label} excluído(a)!`); fetchData(); }
      else notify(res.error || "Erro ao excluir", false);
    } catch (e) { notify("Erro de conexão", false); }
  };

  /* ── COPIAR: preenche formulário sem id ── */
  const copiarProd = (p) => {
    setEditProd(null);
    setFProd({ nome: p.nome + " (cópia)", descricao: p.descricao || "", preco: mascaraPreco(Math.round(parseFloat(p.preco||0)*100)), categoria_id: p.categoria_id || "", subcategoria_id: p.subcategoria_id || "", disponivel: "1", imagem_url: p.imagem_url || "" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const copiarCaixa = (c) => {
    setEditCaixa(null);
    setFCaixa({ nome: c.nome + " (cópia)", descricao: c.descricao || "", preco: mascaraPreco(Math.round(parseFloat(c.preco||0)*100)), preco_original: mascaraPreco(Math.round(parseFloat(c.preco_original||0)*100)), quantidade_limite: c.quantidade_limite || "", ativo: "1", imagem_url: c.imagem_url || "" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ── ADICIONAIS INLINE NO FORM DE PRODUTO ── */
  const adicionarAdiForm = () => {
    if (!novoAdi.nome) { notify("Nome do adicional obrigatório", false); return; }
    setAdisDoForm(p => [...p, { ...novoAdi, _key: Date.now() }]);
    setNovoAdi({ ...emptyAdiForm });
  };
  const removerAdiForm = (key) => setAdisDoForm(p => p.filter(a => a._key !== key));

  const submitProduto = async () => {
    if (!fProd.nome || !fProd.preco) { notify("Nome e preço são obrigatórios", false); return; }
    try {
      const payload = { ...fProd, loja_id: lojaId, preco: desmascarar(fProd.preco), imagem_url: fProd.imagem_url || null };
      let prodId = editProd;
      if (editProd) {
        await put("produtos", editProd, payload);
      } else {
        const res = await post("produtos", payload);
        if (!res.id) { notify(res.error || "Erro ao cadastrar produto", false); return; }
        prodId = res.id;
      }
      /* salvar adicionais novos vinculados */
      for (const a of adisDoForm) {
        await post("adicionais", { nome: a.nome, preco: desmascarar(a.preco), obrigatorio: a.obrigatorio, max_escolhas: a.max_escolhas, imagem_url: a.imagem_url || null, categoria_id: fProd.categoria_id || null, loja_id: lojaId });
      }
      notify(editProd ? "Produto atualizado!" : `Produto cadastrado! ID: ${prodId}`);
      setEditProd(null);
      setFProd({ nome: "", descricao: "", preco: "", categoria_id: "", subcategoria_id: "", disponivel: "1", imagem_url: "" });
      setAdisDoForm([]);
      fetchData();
    } catch (e) { notify("Erro de conexão", false); }
  };

  /* CRUD Promoções */
  const salvarPromo = async () => {
    if (!promoForm.titulo) { notify("Título é obrigatório", false); return; }
    setPromoSalvando(true);
    try {
      const body = { ...promoForm, loja_id: lojaId };
      ["preco_original","preco_promocional"].forEach(k => { if (body[k]) body[k] = desmascarar(body[k]); });
      if (promoEdit) { await put("promocoes", promoEdit, body); setPromoEdit(null); }
      else           { await post("promocoes", body); }
      await fetchPromocoes();
      setPromoForm({ ...emptyPromo });
      setPromoOk(promoEdit ? "Promoção atualizada!" : "Promoção criada com sucesso!");
      setTimeout(() => setPromoOk(""), 3000);
    } catch (e) { notify("Erro: " + e.message, false); }
    setPromoSalvando(false);
  };
  const deletarPromo = async (id) => {
    if (!window.confirm("Remover esta promoção?")) return;
    try { await del("promocoes", id); fetchPromocoes(); notify("Promoção removida"); }
    catch (e) { notify("Erro ao remover", false); }
  };
  const togglePromo = async (p) => {
    const ativa = String(p.ativo) === "1";
    try { await put("promocoes", p.id, { ativo: ativa ? "0" : "1" }); fetchPromocoes(); }
    catch (e) { notify("Erro", false); }
  };
  const handleUploadPromo = async (file) => {
    setUploadingPromo(true);
    try { const r = await uploadArquivo(file, "promocoes"); if (r.url) setPromoForm(p => ({ ...p, imagem_url: r.url })); }
    catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingPromo(false);
  };
  const descPct = (orig, promo) => { const o = parseFloat(orig), p = parseFloat(promo); if (!o || !p || o <= 0) return 0; return Math.round((1 - p / o) * 100); };

  /* Estilos comuns */
  const iS = { width:"100%", padding:"12px 14px", borderRadius:10, border:`1px solid ${C.border}`, background:C.bg, color:C.text, fontSize:14, fontFamily:"inherit", outline:"none" };
  const lS = { fontSize:12, fontWeight:600, color:C.textSoft, marginBottom:6, display:"block" };
  const bS = { padding:14, borderRadius:12, border:"none", color:"#fff", fontWeight:700, fontSize:15, background:C.green, marginTop:12, cursor:"pointer", width:"100%" };
  const bEditS = { ...bS, background:"#3B82F6", marginTop:0 };

  const listCard = (children) => (
    <div style={{ padding:"14px 16px", background:C.bg, borderRadius:12, border:`1px solid ${C.border}`, marginBottom:8 }}>
      {children}
    </div>
  );

  const titles = { categorias:"Categorias", subcategorias:"Sub Categorias", produtos:"Produtos", adicionais:"Adicionais", caixinha:"Caixinha Surpresa", promocoes:"Promoções do Dia" };

  /* ══════════════════════ RENDER PROMOÇÕES ══════════════════════ */
  if (sub === "promocoes") {
    const RED = "#E8201A";
    return (
      <div style={{ animation:"fadeUp .4s ease-out" }}>
        <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:28 }}>
          <div style={{ width:52, height:52, borderRadius:16, background:`${RED}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:26 }}>🔥</div>
          <div>
            <h1 style={{ fontFamily:"'Plus Jakarta Sans'", fontWeight:800, fontSize:28 }}>Promoções do Dia</h1>
            <p style={{ fontSize:13, color:C.textMuted, marginTop:2 }}>Crie ofertas relâmpago que aparecem no app dos clientes</p>
          </div>
          <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:8, padding:"8px 16px", borderRadius:10, background:`${RED}12`, border:`1px solid ${RED}30` }}>
            <div style={{ width:7, height:7, borderRadius:"50%", background:RED, animation:"pulse 1.5s infinite" }} />
            <span style={{ fontSize:12, fontWeight:700, color:RED }}>AO VIVO NO APP</span>
          </div>
        </div>

        {toast && <div style={{ position:"fixed", top:20, left:"50%", transform:"translateX(-50%)", zIndex:999, background:toast.ok ? C.green : RED, color:"#fff", padding:"12px 28px", borderRadius:12, fontWeight:700, fontSize:14, animation:"slideDown .3s ease-out" }}>{toast.msg}</div>}

        <div style={{ display:"grid", gridTemplateColumns:"420px 1fr", gap:24 }}>
          {/* FORMULÁRIO */}
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:18, padding:26, height:"fit-content", position:"sticky", top:24 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
              <h3 style={{ fontSize:16, fontWeight:700, color:C.text }}>{promoEdit ? "✏️ Editando promoção" : "✨ Nova promoção"}</h3>
              {promoEdit && <button onClick={() => { setPromoEdit(null); setPromoForm({ ...emptyPromo }); }} style={{ fontSize:12, color:C.textMuted, background:"transparent", border:`1px solid ${C.border}`, cursor:"pointer", padding:"4px 10px", borderRadius:6 }}>✕ Cancelar</button>}
            </div>
            {/* PREVIEW */}
            <div style={{ marginBottom:20, borderRadius:16, overflow:"hidden", height:160, position:"relative", background:promoForm.imagem_url ? "#111" : (promoForm.cor_fundo || RED), boxShadow:"0 8px 32px rgba(0,0,0,0.35)" }}>
              {promoForm.imagem_url && <img src={promoForm.imagem_url} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", opacity:0.9 }} />}
              {!promoForm.imagem_url && (
                <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:8, padding:"0 24px" }}>
                  <span style={{ fontSize:48 }}>{promoForm.emoji || "🔥"}</span>
                  <span style={{ color:"#fff", fontWeight:800, fontSize:15, textAlign:"center", lineHeight:1.3 }}>{promoForm.titulo || "Título da promoção"}</span>
                  {promoForm.descricao && <span style={{ color:"rgba(255,255,255,.75)", fontSize:12, textAlign:"center" }}>{promoForm.descricao}</span>}
                </div>
              )}
              {promoForm.imagem_url && (promoForm.titulo || promoForm.preco_promocional) && (
                <div style={{ position:"absolute", bottom:0, left:0, right:0, padding:"18px 16px 14px", background:"linear-gradient(transparent,rgba(0,0,0,.82))" }}>
                  {promoForm.titulo && <div style={{ color:"#fff", fontWeight:800, fontSize:15, marginBottom:4 }}>{promoForm.titulo}</div>}
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    {promoForm.preco_original && <span style={{ color:"rgba(255,255,255,.55)", fontSize:12, textDecoration:"line-through" }}>R$ {parseFloat(desmascarar(promoForm.preco_original)||0).toFixed(2).replace(".",",")}</span>}
                    {promoForm.preco_promocional && <span style={{ color:"#FACC15", fontWeight:800, fontSize:17 }}>R$ {parseFloat(desmascarar(promoForm.preco_promocional)||0).toFixed(2).replace(".",",")}</span>}
                  </div>
                </div>
              )}
              {descPct(desmascarar(promoForm.preco_original), desmascarar(promoForm.preco_promocional)) > 0 && (
                <div style={{ position:"absolute", top:12, right:12, background:"#FACC15", color:"#000", fontWeight:900, fontSize:13, padding:"5px 13px", borderRadius:24 }}>
                  {descPct(desmascarar(promoForm.preco_original), desmascarar(promoForm.preco_promocional))}% OFF
                </div>
              )}
              <div style={{ position:"absolute", top:12, left:12, background:"rgba(0,0,0,.5)", color:"rgba(255,255,255,.7)", fontSize:9, fontWeight:700, padding:"3px 8px", borderRadius:6 }}>PREVIEW</div>
            </div>
            {/* CAMPOS */}
            <div style={{ display:"flex", flexDirection:"column", gap:13 }}>
              <div><label style={lS}>Título *</label><input value={promoForm.titulo} onChange={e => setPromoForm(p => ({ ...p, titulo:e.target.value }))} placeholder="Ex: X-Bacon com 40% OFF hoje!" style={iS} /></div>
              <div><label style={lS}>Descrição</label><input value={promoForm.descricao} onChange={e => setPromoForm(p => ({ ...p, descricao:e.target.value }))} placeholder="Só hoje! Aproveite enquanto dura..." style={iS} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div><label style={lS}>Preço Original</label><input inputMode="numeric" value={promoForm.preco_original} onChange={e => setPromoForm(p => ({ ...p, preco_original:mascaraPreco(e.target.value.replace(/\D/g,"")) }))} placeholder="0,00" style={iS} /></div>
                <div><label style={lS}>Preço Promocional</label><input inputMode="numeric" value={promoForm.preco_promocional} onChange={e => setPromoForm(p => ({ ...p, preco_promocional:mascaraPreco(e.target.value.replace(/\D/g,"")) }))} placeholder="0,00" style={iS} /></div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div><label style={lS}>Emoji</label><input value={promoForm.emoji} onChange={e => setPromoForm(p => ({ ...p, emoji:e.target.value }))} placeholder="🔥" style={{ ...iS, fontSize:22, textAlign:"center" }} /></div>
                <div>
                  <label style={lS}>Cor de Fundo</label>
                  <div style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 14px", background:C.bg, border:`1px solid ${C.border}`, borderRadius:10, height:44 }}>
                    <input type="color" value={promoForm.cor_fundo} onChange={e => setPromoForm(p => ({ ...p, cor_fundo:e.target.value }))} style={{ width:28, height:28, border:"none", background:"none", cursor:"pointer", padding:0, borderRadius:4 }} />
                    <span style={{ fontSize:12, color:C.textMuted, fontFamily:"monospace" }}>{promoForm.cor_fundo}</span>
                  </div>
                </div>
              </div>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {["#E8201A","#F97316","#FACC15","#1B8C2D","#3B82F6","#8B5CF6","#EC4899","#0F172A"].map(cor => (
                  <div key={cor} onClick={() => setPromoForm(p => ({ ...p, cor_fundo:cor }))} style={{ width:28, height:28, borderRadius:7, background:cor, cursor:"pointer", border:`2px solid ${promoForm.cor_fundo === cor ? "#fff" : "transparent"}`, transition:"all .15s" }} />
                ))}
              </div>
              <div><label style={lS}>Válido até (opcional)</label><input type="date" value={promoForm.validade} onChange={e => setPromoForm(p => ({ ...p, validade:e.target.value }))} style={iS} /></div>
              <div>
                <label style={lS}>Foto do Produto (substitui emoji + cor)</label>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <label style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 16px", background:C.bg, border:`1px dashed ${uploadingPromo ? C.greenLight : C.border}`, borderRadius:10, cursor:"pointer", color:C.text, fontSize:13, flex:1, justifyContent:"center" }}>
                    {uploadingPromo ? <><div style={{ width:13, height:13, border:`2px solid ${C.greenLight}`, borderTopColor:"transparent", borderRadius:"50%", animation:"spin 1s linear infinite" }} /><span style={{ color:C.greenLight, fontWeight:600 }}>Enviando...</span></> : <><span>📸</span><span>{promoForm.imagem_url ? "Trocar foto" : "Selecionar foto"}</span></>}
                    <input type="file" accept="image/*" style={{ display:"none" }} disabled={uploadingPromo} onChange={e => { if (e.target.files[0]) handleUploadPromo(e.target.files[0]); e.target.value=""; }} />
                  </label>
                  {promoForm.imagem_url && <button onClick={() => setPromoForm(p => ({ ...p, imagem_url:"" }))} style={{ padding:"10px 14px", background:`${RED}18`, border:`1px solid ${RED}30`, borderRadius:10, color:RED, cursor:"pointer", fontSize:13, fontWeight:600 }}>✕ Remover</button>}
                </div>
                {promoForm.imagem_url && <div style={{ marginTop:8, fontSize:11, color:C.greenLight, fontWeight:600 }}>✓ Imagem selecionada</div>}
              </div>
              {promoOk && <div style={{ padding:"11px 14px", background:`${C.greenLight}18`, border:`1px solid ${C.greenLight}40`, borderRadius:9, color:C.greenLight, fontSize:13, fontWeight:700 }}>✓ {promoOk}</div>}
              <button onClick={salvarPromo} disabled={promoSalvando} style={{ ...bS, background:promoSalvando ? C.border : `linear-gradient(135deg,${RED},#FF4444)`, color:promoSalvando ? C.textMuted : "#fff", boxShadow:promoSalvando ? "none" : `0 4px 20px ${RED}35`, marginTop:0 }}>
                {promoSalvando ? "Salvando..." : promoEdit ? "💾 Salvar Alterações" : "🔥 Publicar Promoção"}
              </button>
            </div>
          </div>
          {/* LISTA */}
          <div>
            <div style={{ marginBottom:16 }}>
              <h3 style={{ fontSize:17, fontWeight:700, color:C.text }}>Promoções cadastradas</h3>
              <p style={{ fontSize:12, color:C.textMuted, marginTop:2 }}>{promocoes.filter(p => String(p.ativo) === "1").length} ativa(s) · {promocoes.length} total</p>
            </div>
            {promocoes.length === 0 ? (
              <div style={{ textAlign:"center", padding:"56px 32px", background:C.card, borderRadius:18, border:`2px dashed ${C.border}` }}>
                <div style={{ fontSize:52, marginBottom:14, opacity:.5 }}>🏷️</div>
                <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:6 }}>Nenhuma promoção ainda</div>
                <div style={{ fontSize:13, color:C.textMuted }}>Crie sua primeira promoção no formulário ao lado</div>
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                {promocoes.map((p) => {
                  const pct = descPct(p.preco_original, p.preco_promocional);
                  const ativa = String(p.ativo) === "1";
                  const temImg = p.imagem_url && p.imagem_url.trim() !== "";
                  return (
                    <div key={p.id} style={{ background:C.card, borderRadius:16, overflow:"hidden", display:"flex", alignItems:"stretch", border:`1px solid ${C.border}`, opacity:ativa ? 1 : 0.55, transition:"all .2s" }}>
                      <div style={{ width:110, flexShrink:0, position:"relative", background:temImg ? "#111" : (p.cor_fundo || RED), display:"flex", alignItems:"center", justifyContent:"center", minHeight:96 }}>
                        {temImg && <img src={p.imagem_url} alt="" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover" }} />}
                        {!temImg && <span style={{ fontSize:36 }}>{p.emoji || "🔥"}</span>}
                        {pct > 0 && <div style={{ position:"absolute", top:8, right:8, background:"#FACC15", color:"#000", fontWeight:900, fontSize:10, padding:"2px 8px", borderRadius:12 }}>-{pct}%</div>}
                        {!ativa && <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.55)", display:"flex", alignItems:"center", justifyContent:"center" }}><span style={{ fontSize:18 }}>⏸</span></div>}
                      </div>
                      <div style={{ flex:1, padding:"14px 16px", display:"flex", flexDirection:"column", justifyContent:"space-between", minWidth:0 }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:3, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{p.titulo}</div>
                          {p.descricao && <div style={{ fontSize:12, color:C.textMuted, marginBottom:8, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{p.descricao}</div>}
                          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                            {p.preco_original && <span style={{ fontSize:12, color:C.textMuted, textDecoration:"line-through" }}>R$ {parseFloat(p.preco_original).toFixed(2).replace(".",",")}</span>}
                            {p.preco_promocional && <span style={{ fontSize:18, fontWeight:800, color:C.greenLight }}>R$ {parseFloat(p.preco_promocional).toFixed(2).replace(".",",")}</span>}
                            {pct > 0 && <span style={{ fontSize:11, fontWeight:800, background:"#FACC1520", color:"#FACC15", padding:"3px 10px", borderRadius:10 }}>🔥 {pct}% OFF</span>}
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:8, alignItems:"center", marginTop:8 }}>
                          <span style={{ fontSize:11, padding:"3px 10px", borderRadius:6, fontWeight:700, background:ativa ? `${C.greenLight}20` : `${RED}18`, color:ativa ? C.greenLight : RED }}>{ativa ? "● Ativa" : "○ Pausada"}</span>
                          {p.validade && <span style={{ fontSize:11, color:C.textMuted }}>📅 até {new Date(p.validade+"T12:00:00").toLocaleDateString("pt-BR")}</span>}
                        </div>
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", gap:6, padding:"14px 12px", justifyContent:"center", borderLeft:`1px solid ${C.border}` }}>
                        <button onClick={() => { setPromoEdit(p.id); setPromoForm({ titulo:p.titulo||"", descricao:p.descricao||"", preco_original:p.preco_original ? mascaraPreco(Math.round(parseFloat(p.preco_original)*100)) : "", preco_promocional:p.preco_promocional ? mascaraPreco(Math.round(parseFloat(p.preco_promocional)*100)) : "", imagem_url:p.imagem_url||"", cor_fundo:p.cor_fundo||RED, emoji:p.emoji||"🔥", ativo:p.ativo, validade:p.validade ? String(p.validade).split("T")[0] : "" }); window.scrollTo({ top:0, behavior:"smooth" }); }} style={{ padding:"7px 14px", borderRadius:8, border:`1px solid ${C.border}`, background:"transparent", color:C.text, cursor:"pointer", fontSize:12, fontWeight:600 }}>✏️ Editar</button>
                        <button onClick={() => togglePromo(p)} style={{ padding:"7px 14px", borderRadius:8, border:"none", background:ativa ? `${RED}18` : `${C.greenLight}18`, color:ativa ? RED : C.greenLight, cursor:"pointer", fontSize:12, fontWeight:700 }}>{ativa ? "⏸ Pausar" : "▶ Ativar"}</button>
                        <button onClick={() => deletarPromo(p.id)} style={{ padding:"7px 14px", borderRadius:8, border:"none", background:`${RED}12`, color:RED, cursor:"pointer", fontSize:12, fontWeight:700 }}>🗑 Excluir</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  /* ══════════════════════ RENDER PADRÃO ══════════════════════ */
  const editando = editCat || editSub || editProd || editAdi || editCaixa;

  return (
    <div style={{ animation:"fadeUp .4s ease-out" }}>
      <div style={{ marginBottom:24, display:"flex", alignItems:"center", gap:12 }}>
        <h1 style={{ fontFamily:"'Plus Jakarta Sans'", fontWeight:800, fontSize:28 }}>{titles[sub]}</h1>
        {editando && (
          <span style={{ fontSize:12, background:"#3B82F618", color:"#3B82F6", border:"1px solid #3B82F630", borderRadius:8, padding:"4px 12px", fontWeight:700 }}>
            ✏️ Modo edição — preencha e salve
          </span>
        )}
      </div>

      {toast && <div style={{ position:"fixed", top:20, left:"50%", transform:"translateX(-50%)", zIndex:999, background:toast.ok ? C.green : C.red, color:"#fff", padding:"12px 28px", borderRadius:12, fontWeight:700, fontSize:14, animation:"slideDown .3s ease-out" }}>{toast.msg}</div>}

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20 }}>

        {/* ── FORMULÁRIO ── */}
        <Card>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <h3 style={{ fontSize:18, fontWeight:700 }}>{editando ? "✏️ Editar" : "Novo Cadastro"}</h3>
            {editando && (
              <button onClick={() => { setEditCat(null); setEditSub(null); setEditProd(null); setEditAdi(null); setEditCaixa(null); setFCat({ nome:"", descricao:"", ordem:"0" }); setFSub({ nome:"", categoria_id:"", descricao:"" }); setFProd({ nome:"", descricao:"", preco:"", categoria_id:"", subcategoria_id:"", disponivel:"1" }); setFAdi({ nome:"", preco:"", categoria_id:"", obrigatorio:"0", max_escolhas:"1" }); setFCaixa({ nome:"", descricao:"", preco:"", preco_original:"", quantidade_limite:"", ativo:"1", imagem_url:"" }); setAdisDoForm([]); }}
                style={{ fontSize:12, color:C.textMuted, background:"transparent", border:`1px solid ${C.border}`, cursor:"pointer", padding:"4px 10px", borderRadius:6 }}>
                ✕ Cancelar
              </button>
            )}
          </div>

          {/* CATEGORIAS */}
          {sub === "categorias" && <>
            <Field label="Nome da Categoria *" ph="Ex: Hambúrgueres" value={fCat.nome} onChange={v => setFCat({ ...fCat, nome:v })} />
            <Field label="Descrição" ph="Descrição da categoria" value={fCat.descricao} onChange={v => setFCat({ ...fCat, descricao:v })} />
            <Field label="Ordem" ph="0" type="number" value={fCat.ordem} onChange={v => setFCat({ ...fCat, ordem:v })} />
            <button onClick={() => submitForm("categorias_loja", fCat, "Categoria", () => { setFCat({ nome:"", descricao:"", ordem:"0" }); setEditCat(null); }, editCat)} style={editCat ? bEditS : bS}>
              {editCat ? "💾 Salvar Alterações" : "Cadastrar Categoria"}
            </button>
          </>}

          {/* SUB CATEGORIAS */}
          {sub === "subcategorias" && <>
            <SelectField label="Categoria *" value={fSub.categoria_id} onChange={v => setFSub({ ...fSub, categoria_id:v })} options={[{ v:"", l:"Selecione" }, ...categorias.map(c => ({ v:c.id, l:c.nome }))]} />
            <Field label="Nome *" ph="Ex: Artesanais" value={fSub.nome} onChange={v => setFSub({ ...fSub, nome:v })} />
            <Field label="Descrição" ph="Descrição" value={fSub.descricao} onChange={v => setFSub({ ...fSub, descricao:v })} />
            <button onClick={() => submitForm("subcategorias", fSub, "Sub Categoria", () => { setFSub({ nome:"", categoria_id:"", descricao:"" }); setEditSub(null); }, editSub)} style={editSub ? bEditS : bS}>
              {editSub ? "💾 Salvar Alterações" : "Cadastrar Sub Categoria"}
            </button>
          </>}

          {/* PRODUTOS */}
          {sub === "produtos" && <>
            <Field label="Nome do Produto *" ph="Ex: X-Bacon Duplo" value={fProd.nome} onChange={v => setFProd({ ...fProd, nome:v })} />
            <Field label="Descrição" ph="Ingredientes, detalhes..." value={fProd.descricao} onChange={v => setFProd({ ...fProd, descricao:v })} />
            <Field label="Preço (R$) *" ph="0,00" money value={fProd.preco} onChange={v => setFProd({ ...fProd, preco:v })} />
            <SelectField label="Categoria" value={fProd.categoria_id} onChange={v => setFProd({ ...fProd, categoria_id:v, subcategoria_id:"" })} options={[{ v:"", l:"Selecione" }, ...categorias.map(c => ({ v:c.id, l:c.nome }))]} />
            <SelectField label="Sub Categoria" value={fProd.subcategoria_id} onChange={v => setFProd({ ...fProd, subcategoria_id:v })} options={[{ v:"", l:"Nenhuma" }, ...subcategorias.filter(s => !fProd.categoria_id || String(s.categoria_id) === String(fProd.categoria_id)).map(s => ({ v:s.id, l:s.nome }))]} />
            <SelectField label="Disponível" value={fProd.disponivel} onChange={v => setFProd({ ...fProd, disponivel:v })} options={[{ v:"1", l:"Sim" }, { v:"0", l:"Não" }]} />

            {/* IMAGEM DO PRODUTO */}
            <div style={{ marginBottom: 14 }}>
              <label style={_lS}>Foto do Produto</label>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", background: C.bg, border: `1px dashed ${uploadingProd ? C.greenLight : C.border}`, borderRadius: 10, cursor: "pointer", color: C.text, fontSize: 13, flex: 1, justifyContent: "center" }}>
                  {uploadingProd
                    ? <><div style={{ width: 13, height: 13, border: `2px solid ${C.greenLight}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 1s linear infinite" }} /><span style={{ color: C.greenLight, fontWeight: 600 }}>Enviando...</span></>
                    : <><span>📸</span><span>{fProd.imagem_url ? "Trocar foto" : "Selecionar foto"}</span></>}
                  <input type="file" accept="image/*" style={{ display: "none" }} disabled={uploadingProd} onChange={e => { if (e.target.files[0]) handleUploadProd(e.target.files[0]); e.target.value = ""; }} />
                </label>
                {fProd.imagem_url && <button onClick={() => setFProd(p => ({ ...p, imagem_url: "" }))} style={{ padding: "10px 14px", background: "#E8201A18", border: "1px solid #E8201A30", borderRadius: 10, color: "#E8201A", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>✕</button>}
              </div>
              {fProd.imagem_url && (
                <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}>
                  <img src={fProd.imagem_url} alt="" style={{ width: 56, height: 56, borderRadius: 10, objectFit: "cover", border: `1px solid ${C.border}` }} />
                  <span style={{ fontSize: 11, color: C.greenLight, fontWeight: 600 }}>✓ Imagem selecionada</span>
                </div>
              )}
            </div>

            {/* ── ADICIONAIS INLINE ── */}
            <div style={{ marginTop:18, paddingTop:18, borderTop:`2px dashed ${C.border}` }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:14 }}>
                <span style={{ fontSize:13, fontWeight:700, color:C.text }}>➕ Adicionais do Produto</span>
                <span style={{ fontSize:11, color:C.textMuted }}>{adisDoForm.length} adicionado(s)</span>
              </div>

              {adisDoForm.length > 0 && (
                <div style={{ marginBottom:12 }}>
                  {adisDoForm.map(a => (
                    <div key={a._key} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:C.bg, border:`1px solid ${C.border}`, borderRadius:9, marginBottom:6, fontSize:13 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                        {a.imagem_url && <img src={a.imagem_url} alt="" style={{ width:28, height:28, borderRadius:6, objectFit:"cover" }} />}
                        <span>{a.nome} <span style={{ color:C.textMuted }}>— R$ {a.preco || "0,00"}</span> {a.obrigatorio === "1" && <span style={{ color:"#E8201A", fontSize:11 }}>obrigatório</span>}</span>
                      </div>
                      <button onClick={() => removerAdiForm(a._key)} style={{ background:"none", border:"none", color:"#E8201A", cursor:"pointer", fontWeight:700, fontSize:14 }}>✕</button>
                    </div>
                  ))}
                </div>
              )}

              <div style={{ background:C.bg, border:`1px solid ${C.border}`, borderRadius:12, padding:14 }}>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                  <div><label style={_lS}>Nome do Adicional</label><input value={novoAdi.nome} onChange={e => setNovoAdi(p => ({ ...p, nome:e.target.value }))} placeholder="Ex: Bacon Extra" style={_iS} /></div>
                  <div><label style={_lS}>Preço</label><input inputMode="numeric" value={novoAdi.preco} onChange={e => setNovoAdi(p => ({ ...p, preco:mascaraPreco(e.target.value.replace(/\D/g,"")) }))} placeholder="0,00" style={_iS} /></div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                  <div>
                    <label style={_lS}>Obrigatório</label>
                    <select value={novoAdi.obrigatorio} onChange={e => setNovoAdi(p => ({ ...p, obrigatorio:e.target.value }))} style={_iS}>
                      <option value="0">Não</option><option value="1">Sim</option>
                    </select>
                  </div>
                  <div><label style={_lS}>Máx. Escolhas</label><input type="number" value={novoAdi.max_escolhas} onChange={e => setNovoAdi(p => ({ ...p, max_escolhas:e.target.value }))} placeholder="1" style={_iS} /></div>
                </div>
                <div style={{ marginBottom:10 }}>
                  <label style={_lS}>Foto do Adicional (opcional)</label>
                  <label style={{ display:"flex", alignItems:"center", gap:8, padding:"9px 14px", background:C.bg, border:`1px dashed ${C.border}`, borderRadius:9, cursor:"pointer", fontSize:12, color:C.text, justifyContent:"center" }}>
                    <span>📸</span><span>{novoAdi.imagem_url ? "Trocar foto" : "Selecionar foto"}</span>
                    <input type="file" accept="image/*" style={{ display:"none" }} onChange={e => { if (e.target.files[0]) { uploadArquivo(e.target.files[0], "adicional").then(r => { if (r.url) setNovoAdi(p => ({ ...p, imagem_url: r.url })); }); } e.target.value=""; }} />
                  </label>
                  {novoAdi.imagem_url && <div style={{ marginTop:6, display:"flex", alignItems:"center", gap:8 }}><img src={novoAdi.imagem_url} alt="" style={{ width:36, height:36, borderRadius:7, objectFit:"cover" }} /><span style={{ fontSize:11, color:C.greenLight, fontWeight:600 }}>✓ Selecionada</span><button onClick={() => setNovoAdi(p => ({ ...p, imagem_url:"" }))} style={{ background:"none", border:"none", color:"#E8201A", cursor:"pointer", fontSize:12 }}>✕</button></div>}
                </div>
                <button onClick={adicionarAdiForm} style={{ width:"100%", padding:"9px 0", borderRadius:9, border:`1px dashed ${C.green}`, background:`${C.green}12`, color:C.green, fontWeight:700, fontSize:13, cursor:"pointer" }}>
                  + Adicionar à lista
                </button>
              </div>
            </div>

            <button onClick={submitProduto} style={editProd ? bEditS : bS}>
              {editProd ? "💾 Salvar Produto" : "Cadastrar Produto"}
            </button>
          </>}

          {/* ADICIONAIS standalone */}
          {sub === "adicionais" && <>
            <Field label="Nome *" ph="Ex: Bacon Extra" value={fAdi.nome} onChange={v => setFAdi({ ...fAdi, nome:v })} />
            <Field label="Preço (R$) *" ph="0,00" money value={fAdi.preco} onChange={v => setFAdi({ ...fAdi, preco:v })} />
            <SelectField label="Categoria" value={fAdi.categoria_id} onChange={v => setFAdi({ ...fAdi, categoria_id:v })} options={[{ v:"", l:"Todas" }, ...categorias.map(c => ({ v:c.id, l:c.nome }))]} />
            <SelectField label="Obrigatório" value={fAdi.obrigatorio} onChange={v => setFAdi({ ...fAdi, obrigatorio:v })} options={[{ v:"0", l:"Não" }, { v:"1", l:"Sim" }]} />
            <Field label="Máx Escolhas" ph="1" type="number" value={fAdi.max_escolhas} onChange={v => setFAdi({ ...fAdi, max_escolhas:v })} />
            <div style={{ marginBottom:14 }}>
              <label style={lS}>Foto do Adicional (opcional)</label>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <label style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 16px", background:C.bg, border:`1px dashed ${uploadingAdi ? C.greenLight : C.border}`, borderRadius:10, cursor:"pointer", color:C.text, fontSize:13, flex:1, justifyContent:"center" }}>
                  {uploadingAdi
                    ? <><div style={{ width:13, height:13, border:`2px solid ${C.greenLight}`, borderTopColor:"transparent", borderRadius:"50%", animation:"spin 1s linear infinite" }} /><span style={{ color:C.greenLight, fontWeight:600 }}>Enviando...</span></>
                    : <><span>📸</span><span>{fAdi.imagem_url ? "Trocar foto" : "Selecionar foto"}</span></>}
                  <input type="file" accept="image/*" style={{ display:"none" }} disabled={uploadingAdi}
                    onChange={e => { if (e.target.files[0]) { setUploadingAdi(true); uploadArquivo(e.target.files[0], "adicional").then(r => { if (r.url) setFAdi(p => ({ ...p, imagem_url:r.url })); setUploadingAdi(false); }); } e.target.value=""; }} />
                </label>
                {fAdi.imagem_url && <button onClick={() => setFAdi(p => ({ ...p, imagem_url:"" }))} style={{ padding:"10px 14px", background:"#E8201A18", border:"1px solid #E8201A30", borderRadius:10, color:"#E8201A", cursor:"pointer", fontSize:13, fontWeight:600 }}>✕</button>}
              </div>
              {fAdi.imagem_url && (
                <div style={{ marginTop:8, display:"flex", alignItems:"center", gap:8 }}>
                  <img src={fAdi.imagem_url} alt="" style={{ width:48, height:48, borderRadius:8, objectFit:"cover", border:`1px solid ${C.border}` }} />
                  <span style={{ fontSize:11, color:C.greenLight, fontWeight:600 }}>✓ Imagem selecionada</span>
                </div>
              )}
            </div>
            <button onClick={() => submitForm("adicionais", fAdi, "Adicional", () => { setFAdi({ nome:"", preco:"", categoria_id:"", obrigatorio:"0", max_escolhas:"1", imagem_url:"" }); setEditAdi(null); }, editAdi)} style={editAdi ? bEditS : bS}>
              {editAdi ? "💾 Salvar Adicional" : "Cadastrar Adicional"}
            </button>
          </>}

          {/* CAIXINHA */}
          {sub === "caixinha" && <>
            <Field label="Nome *" ph="Ex: Caixinha do Chef" value={fCaixa.nome} onChange={v => setFCaixa(p => ({ ...p, nome:v }))} />
            <Field label="Descrição" ph="Descrição da caixinha" value={fCaixa.descricao} onChange={v => setFCaixa(p => ({ ...p, descricao:v }))} />
            <Field label="Preço Promocional (R$) *" ph="0,00" money value={fCaixa.preco} onChange={v => setFCaixa(p => ({ ...p, preco:v }))} />
            <Field label="Preço Original (R$)" ph="0,00" money value={fCaixa.preco_original} onChange={v => setFCaixa(p => ({ ...p, preco_original:v }))} />
            <Field label="Limite de Unidades" ph="50" type="number" value={fCaixa.quantidade_limite} onChange={v => setFCaixa(p => ({ ...p, quantidade_limite:v }))} />
            <SelectField label="Ativo" value={fCaixa.ativo} onChange={v => setFCaixa(p => ({ ...p, ativo:v }))} options={[{ v:"1", l:"Sim" }, { v:"0", l:"Não" }]} />
            <div style={{ marginBottom:14 }}>
              <label style={lS}>Foto da Caixinha</label>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <label style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 16px", background:C.bg, border:`1px dashed ${uploadingCaixa ? "#22C55E" : C.border}`, borderRadius:10, cursor:"pointer", color:C.text, fontSize:13, flex:1, justifyContent:"center" }}>
                  {uploadingCaixa ? <><div style={{ width:13, height:13, border:"2px solid #22C55E", borderTopColor:"transparent", borderRadius:"50%", animation:"spin 1s linear infinite" }} /><span style={{ color:"#22C55E", fontWeight:600 }}>Enviando...</span></> : <><span>📸</span><span>{fCaixa.imagem_url ? "Trocar foto" : "Selecionar foto"}</span></>}
                  <input type="file" accept="image/*" style={{ display:"none" }} disabled={uploadingCaixa} onChange={e => { if (e.target.files[0]) handleUploadCaixa(e.target.files[0]); e.target.value=""; }} />
                </label>
                {fCaixa.imagem_url && <button onClick={() => setFCaixa(p => ({ ...p, imagem_url:"" }))} style={{ padding:"10px 14px", background:"#E8201A18", border:"1px solid #E8201A30", borderRadius:10, color:"#E8201A", cursor:"pointer", fontSize:13, fontWeight:600 }}>✕</button>}
              </div>
              {fCaixa.imagem_url && (
                <div style={{ marginTop:8, display:"flex", alignItems:"center", gap:8 }}>
                  <img src={fCaixa.imagem_url} alt="" style={{ width:48, height:48, borderRadius:8, objectFit:"cover", border:`1px solid ${C.border}` }} />
                  <span style={{ fontSize:11, color:"#22C55E", fontWeight:600 }}>✓ Imagem selecionada</span>
                </div>
              )}
            </div>
            <button onClick={() => submitForm("caixinha_surpresa", fCaixa, "Caixinha", () => { setFCaixa({ nome:"", descricao:"", preco:"", preco_original:"", quantidade_limite:"", ativo:"1", imagem_url:"" }); setEditCaixa(null); }, editCaixa)} style={editCaixa ? bEditS : bS}>
              {editCaixa ? "💾 Salvar Caixinha" : "Cadastrar Caixinha"}
            </button>
          </>}
        </Card>

        {/* ── LISTA ── */}
        <Card>
          <h3 style={{ fontSize:18, fontWeight:700, marginBottom:20 }}>{titles[sub]} Cadastrados</h3>

          {sub === "categorias" && (categorias.length === 0 ? <EmptyState text="Nenhuma categoria" /> :
            categorias.map(c => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:700 }}>{c.nome}</span>
                  <span style={{ fontSize:11, fontWeight:700, color:C.greenLight, background:`${C.greenLight}15`, padding:"3px 10px", borderRadius:6 }}>Ativo</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>{c.descricao || "—"} · Ordem: {c.ordem||0} · ID: {c.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditCat(c.id); setFCat({ nome:c.nome, descricao:c.descricao||"", ordem:String(c.ordem||0) }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onExcluir={() => excluir("categorias_loja", c.id, "Categoria")}
                />
              </>
            ))
          )}

          {sub === "subcategorias" && (subcategorias.length === 0 ? <EmptyState text="Nenhuma sub categoria" /> :
            subcategorias.map(s => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:700 }}>{s.nome}</span>
                  <span style={{ fontSize:11, fontWeight:700, color:C.greenLight, background:`${C.greenLight}15`, padding:"3px 10px", borderRadius:6 }}>Ativo</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>Categoria: {categorias.find(c => String(c.id) === String(s.categoria_id))?.nome || "#"+s.categoria_id} · ID: {s.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditSub(s.id); setFSub({ nome:s.nome, categoria_id:String(s.categoria_id), descricao:s.descricao||"" }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onExcluir={() => excluir("subcategorias", s.id, "Sub Categoria")}
                />
              </>
            ))
          )}

          {sub === "produtos" && (produtos.length === 0 ? <EmptyState text="Nenhum produto" /> :
            <div style={{ maxHeight:600, overflowY:"auto" }}>
              {produtos.map(p => listCard(
                <>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      {p.imagem_url && <img src={p.imagem_url} alt="" style={{ width:44, height:44, borderRadius:9, objectFit:"cover", border:`1px solid ${C.border}`, flexShrink:0 }} />}
                      <span style={{ fontWeight:700 }}>{p.nome}</span>
                    </div>
                    <span style={{ fontSize:13, fontWeight:800, color:C.greenLight, flexShrink:0 }}>R$ {parseFloat(p.preco||0).toFixed(2).replace(".",",")}</span>
                  </div>
                  <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>
                    {categorias.find(c => String(c.id) === String(p.categoria_id))?.nome || "—"} · {p.descricao || "—"} · ID: {p.id}
                  </div>
                  <div style={{ marginTop:6 }}>
                    <span style={{ fontSize:11, fontWeight:700, color: (p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? C.greenLight : "#E8201A", background: (p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? `${C.greenLight}15` : "#E8201A15", padding:"2px 8px", borderRadius:6 }}>
                      {(p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? "Disponível" : "Indisponível"}
                    </span>
                  </div>
                  <AcoesBotoes C={C}
                    onEditar={() => { setEditProd(p.id); setFProd({ nome:p.nome, descricao:p.descricao||"", preco:mascaraPreco(Math.round(parseFloat(p.preco||0)*100)), categoria_id:String(p.categoria_id||""), subcategoria_id:String(p.subcategoria_id||""), disponivel:String(p.disponivel||"1"), imagem_url:p.imagem_url||"" }); setAdisDoForm([]); window.scrollTo({ top:0, behavior:"smooth" }); }}
                    onCopiar={() => copiarProd(p)}
                    onExcluir={() => excluir("produtos", p.id, "Produto")}
                  />
                </>
              ))}
            </div>
          )}

          {sub === "adicionais" && (adicionais.length === 0 ? <EmptyState text="Nenhum adicional" /> :
            adicionais.map(a => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    {a.imagem_url && <img src={a.imagem_url} alt="" style={{ width:40, height:40, borderRadius:9, objectFit:"cover", border:`1px solid ${C.border}`, flexShrink:0 }} />}
                    <span style={{ fontWeight:700 }}>{a.nome}</span>
                  </div>
                  <span style={{ fontSize:13, fontWeight:800, color:C.greenLight, flexShrink:0 }}>R$ {parseFloat(a.preco||0).toFixed(2).replace(".",",")}</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>{a.obrigatorio ? "Obrigatório" : "Opcional"} · Máx: {a.max_escolhas||1} · ID: {a.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditAdi(a.id); setFAdi({ nome:a.nome, preco:mascaraPreco(Math.round(parseFloat(a.preco||0)*100)), categoria_id:String(a.categoria_id||""), obrigatorio:String(a.obrigatorio||"0"), max_escolhas:String(a.max_escolhas||1), imagem_url:a.imagem_url||"" }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onExcluir={() => excluir("adicionais", a.id, "Adicional")}
                />
              </>
            ))
          )}

          {sub === "caixinha" && (caixinhas.length === 0 ? <EmptyState text="Nenhuma caixinha" /> :
            caixinhas.map(c => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:700 }}>{c.nome}</span>
                  <span style={{ fontSize:13, fontWeight:800, color:C.greenLight }}>R$ {parseFloat(c.preco||0).toFixed(2).replace(".",",")}</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>Original: R$ {parseFloat(c.preco_original||0).toFixed(2).replace(".",",")} · Limite: {c.quantidade_limite||"∞"} · ID: {c.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditCaixa(c.id); setFCaixa({ nome:c.nome, descricao:c.descricao||"", preco:mascaraPreco(Math.round(parseFloat(c.preco||0)*100)), preco_original:mascaraPreco(Math.round(parseFloat(c.preco_original||0)*100)), quantidade_limite:String(c.quantidade_limite||""), ativo:String(c.ativo||"1"), imagem_url:c.imagem_url||"" }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onCopiar={() => copiarCaixa(c)}
                  onExcluir={() => excluir("caixinha_surpresa", c.id, "Caixinha")}
                />
              </>
            ))
          )}
        </Card>
      </div>
    </div>
  );
}